import { render, staticRenderFns } from "./VuesticCollapse.vue?vue&type=template&id=24e9aa0a"
import script from "./VuesticCollapse.vue?vue&type=script&lang=js"
export * from "./VuesticCollapse.vue?vue&type=script&lang=js"
import style0 from "./VuesticCollapse.vue?vue&type=style&index=0&id=24e9aa0a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e9aa0a')) {
      api.createRecord('24e9aa0a', component.options)
    } else {
      api.reload('24e9aa0a', component.options)
    }
    module.hot.accept("./VuesticCollapse.vue?vue&type=template&id=24e9aa0a", function () {
      api.rerender('24e9aa0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-collapse/VuesticCollapse.vue"
export default component.exports